"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbortableOperation = /** @class */ (function () {
    function AbortableOperation(promise, onAbort) {
        this.promise = promise;
        this.onAbort = onAbort;
        this.hasAborted = false;
    }
    AbortableOperation.prototype.finally = function (onFinal) {
        this.promise.then(function (_ /*value*/) { return onFinal(true); }, function (_ /*error*/) { return onFinal(false); });
        return this;
    };
    AbortableOperation.prototype.abort = function () {
        if (this.hasAborted) {
            return;
        }
        this.hasAborted = true;
        return this.onAbort();
    };
    AbortableOperation.prototype.then = function (x) {
        return this.promise.then(x);
    };
    return AbortableOperation;
}());
exports.default = AbortableOperation;
//# sourceMappingURL=AbortableOperation.js.map